import { useState } from 'react';
import Button from '../general/Button';
import SearchQuery from '../general/SearchQuery';
import GameAnswer from '../game/GameAnswer';
import InputTile from '../text/InputTile';
import { useLanguage } from '../../context/LanguageContext';

export default function GameCard({ hasRoundFinished, text, suggestions, correctSuggestions, onGuess }) {
  const { t } = useLanguage();

  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (inputValue.trim()) {
      onGuess(inputValue);
      setInputValue('');
    }
  };

  return (
    <div className="mx-4 bg-white dark:bg-background-dark dark:text-text-dark text-sm rounded-2xl sm:w-full">
      {/*top part*/}
      <form onSubmit={handleSubmit}>
        <div className="flex items-center justify-between rounded-t-2xl border border-gray">
          <div className="flex items-center">
            <div className="hidden sm:inline">
              <SearchQuery text={`${text}...`} />
            </div>
            <div className="inline sm:hidden px-2">
              <span className="truncate max-w-xs">{text}</span>
            </div>
            <InputTile
              disable={hasRoundFinished}
              type="game"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
          <Button type="submit" category="gamebar" text={t('search')} active={!hasRoundFinished} />
          <Button type="submit" category="gamebarsmall" text="🔍" active={!hasRoundFinished} />
        </div>
      </form>
      {/*bottom part*/}
      <div className="py-3 rounded-b-2xl border-r border-l border-b border-gray">
        {suggestions &&
          suggestions.map((item, index) => {
            const isGuessed = correctSuggestions.includes(item.suggestion);
            return (
              <GameAnswer
                hasRoundFinished={hasRoundFinished}
                key={index}
                query={text}
                answer={item.suggestion}
                isFound={isGuessed}
                points={item.points}
              />
            );
          })}
      </div>
    </div>
  );
}
